
<div class="container" [style.cursor]="'pointer'">
    <img [id]="data.id" [routerLink]="data.url" [src]="'./assets/banners/'+data.img" alt="">
</div>